import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

import {AvatarSize, AvatarShape} from './AvatarConstants';

const DEFAULT_AVATAR_SHAPE = AvatarShape.CIRCLE;

interface AvatarTextProps {
  text: string;
  backgroundColor: string;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
  size: AvatarSize;
  shape?: AvatarShape;
}

/**
 * A text-only avatar with text over a circle with a background color.
 */
const AvatarText = ({
  text,
  backgroundColor,
  className,
  dataTestAttrs,
  size,
  shape = DEFAULT_AVATAR_SHAPE,
}: AvatarTextProps): JSX.Element => (
  <span
    translate="no"
    className={classNames(`avatar avatar--text avatar--${size} avatar--${shape}`, className)}
    style={{backgroundColor}}
    {...getTestProps(dataTestAttrs)}
  >
    {text}
  </span>
);
export default AvatarText;
